<template lang="pug">
AppToggleDropdown(
  trigger-classes="btn btn-icon btn-naked"
  :tooltip-options="{ placement: 'left' }"
  title="Table Columns"
)
  template(#trigger)
    i.hi.hi-columns.hi-16
  template(#header) Table columns
  AppColumnToggle(
    disabled
    active
    @change="handleChange"
  ) Member
  AppColumnToggle(
    :active="columns.show_member_info"
    column="show_member_info"
    has-submenu
    @change="handleChange"
  )
    .app-toggle-dropdown
      | Info
      MembersInfoFields(
        :about-fields="infoFields"
        list-classes="dropdown-menu dropdown-submenu-left"
        @change="handleChange"
      )
  AppColumnToggle(
    :active="columns.show_member_employment"
    column="show_member_employment"
    has-submenu
    @change="handleChange"
  )
    .app-toggle-dropdown
      | Employment
      MembersEmploymentFields(
        :about-fields="employmentFields"
        list-classes="dropdown-menu dropdown-submenu-left"
        @change="handleChange"
      )
  AppColumnToggle(
    v-if="hasCorporateApp"
    column="show_email"
    :active="columns.show_email"
    @change="handleChange"
  ) Work email
  AppColumnToggle(
    column="show_status"
    :active="columns.show_status"
    @change="handleChange"
  ) Status
  AppColumnToggle(
    column="show_role"
    :active="columns.show_role"
    @change="handleChange"
  ) Role
  AppColumnToggle(
    v-if="showTeamsUI"
    column="show_teams"
    :active="columns.show_teams"
    @change="handleChange"
  ) Teams
  AppColumnToggle(
    v-if="hasProjects"
    column="show_projects"
    :active="columns.show_projects"
    @change="handleChange"
  ) Projects
  AppColumnToggle(
    v-if="hasWorkOrders"
    column="show_work_orders"
    :active="columns.show_work_orders"
    @change="handleChange"
  ) Work orders
  AppColumnToggle(
    column="show_payment"
    :active="columns.show_payment"
    @change="handleChange"
  ) Payment
  AppColumnToggle(
    column="show_limits"
    :active="columns.show_limits"
    @change="handleChange"
  ) Limits
  AppColumnToggle(
    column="show_screenshots"
    :active="columns.show_screenshots"
    @change="handleChange"
  ) Screenshots
  AppColumnToggle(
    column="show_apps_urls"
    :active="columns.show_apps_urls"
    @change="handleChange"
  ) Apps & URLs
  AppColumnToggle(
    column="show_time_tracking"
    :active="columns.show_time_tracking"
    @change="handleChange"
  ) Time tracking
  AppColumnToggle(
    column="show_date_added"
    :active="columns.show_date_added"
    @change="handleChange"
  ) Date added
  AppColumnToggle(
    column="show_date_removed"
    :active="columns.show_date_removed"
    @change="handleChange"
  ) Date removed
</template>

<script>
import AppToggleDropdown from '../AppToggleDropdown.vue';
import AppColumnToggle from '../AppColumnToggle.vue';
import MembersInfoFields from '~/components/members/MembersInfoFields.vue';
import MembersEmploymentFields from '~/components/members/MembersEmploymentFields.vue';

export default {
  name: 'MembersColumnPicker',
  components: {
    AppToggleDropdown,
    AppColumnToggle,
    MembersInfoFields,
    MembersEmploymentFields,
  },
  props: {
    infoFields: {
      type: Object,
      default: () => ({}),
    },
    employmentFields: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Object,
      default: () => ({}),
    },
    hasProjects: {
      type: Boolean,
      default: false,
    },
    hasWorkOrders: {
      type: Boolean,
      default: false,
    },
    showTeamsUI: {
      type: Boolean,
      default: false,
    },
    hasCorporateApp: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  methods: {
    handleChange(payload) {
      this.$emit('change', { ...this.columns, ...payload });
    },
  },
};
</script>
